import { render, staticRenderFns } from "./item-info-popup.html?vue&type=template&id=00f9860d&scoped=true&external"
import script from "./item-info-popup.js?vue&type=script&lang=js&external"
export * from "./item-info-popup.js?vue&type=script&lang=js&external"
import style0 from "./item-info-popup.scss?vue&type=style&index=0&id=00f9860d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f9860d",
  null
  
)

export default component.exports